import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M19.5 9.5h-.75V6.75A6.75 6.75 0 0 0 5.53 4.81a1.25 1.25 0 0 0 2.4.72 4.25 4.25 0 0 1 8.32 1.22V9a.5.5 0 0 1-.5.5H4.5a2 2 0 0 0-2 2V22a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V11.5a2 2 0 0 0-2-2m-7.5 9a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
    }, null, -1)
  ]));
}
const Unlock = { render };
export {
  Unlock as default,
  render
};
//# sourceMappingURL=Unlock.svg.js.map
